var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent12Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/event") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/event",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.458333, 0.250777)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94986111,6.88338275e-15 C8.21909993,6.88338275e-15 8.44245887,0.196435066 8.48443828,0.45380552 L8.49152778,0.541666667 L8.491,1.156 L10.5913889,1.15600607 C10.8606277,1.15600607 11.0839867,1.35244114 11.1259661,1.60981159 L11.1330556,1.69767274 L11.1330556,10.8735061 C11.1330556,11.1726603 10.8905431,11.4151727 10.5913889,11.4151727 L10.5913889,11.4151727 L0.541666667,11.4151727 C0.242512427,11.4151727 4.20996571e-13,11.1726603 4.20996571e-13,10.8735061 L4.20996571e-13,10.8735061 L4.20996571e-13,1.69767274 C4.20996571e-13,1.3985185 0.242512427,1.15600607 0.541666667,1.15600607 L0.541666667,1.15600607 L2.641,1.156 L2.64152778,0.541666667 C2.64152778,0.242512427 2.8840402,6.88338275e-15 3.18319444,6.88338275e-15 C3.45243326,6.88338275e-15 3.67579221,0.196435066 3.71777161,0.45380552 L3.72486111,0.541666667 L3.724,1.156 L7.408,1.156 L7.40819444,0.541666667 C7.40819444,0.242512427 7.65070687,6.88338275e-15 7.94986111,6.88338275e-15 Z M10.049,5.377 L1.082,5.377 L1.08266667,10.3312232 L10.0496667,10.3312232 L10.049,5.377 Z M2.641,2.239 L1.08266667,2.23922321 L1.082,4.294 L10.049,4.294 L10.0496667,2.23922321 L8.491,2.239 L8.49152778,2.64282316 C8.49152778,2.9419774 8.24901535,3.18448983 7.94986111,3.18448983 C7.6806223,3.18448983 7.45726335,2.98805476 7.41528395,2.73068431 L7.40819444,2.64282316 L7.408,2.239 L3.724,2.239 L3.72486111,2.64282316 C3.72486111,2.9419774 3.48234868,3.18448983 3.18319444,3.18448983 C2.91395563,3.18448983 2.69059668,2.98805476 2.64861728,2.73068431 L2.64152778,2.64282316 L2.641,2.239 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent12Px);
export default __webpack_public_path__ + "static/media/event_12px.6efdbe61.svg";
export { ForwardRef as ReactComponent };